<template>
  <header id="headBox" class="HeadMobileMode" :class="{'moveDown':scrollState,'current':navUnfold}">
    <div class="suspension" @click="navUnfold = !navUnfold">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="pageCenter">
      <router-link class="logo" to="/"></router-link>
      <ul>
        <router-link tag="li" to='/'>首页</router-link>
        <router-link tag="li" to='/cases'>电商系统</router-link>
        <!-- <router-link tag="li" to='/template'>便宜模板</router-link> -->
        <router-link tag="li" to='/news'>行业资讯</router-link>
        <router-link tag="li" to='/aboutUs'>关于商鼎云</router-link>
        <router-link tag="li" to='/contactUs'>联系我们</router-link>
      </ul>
    </div>
  </header>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    slide: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      scrollState: false,
      navUnfold: false
    };
  },
  mounted() {
    if (this.slide) {
      this.scrollState = false;
      this.onScroll();
    } else {
      this.scrollState = true;
    }

    //接收滚动事件
    this.$parent.$parent.$on("pageScroll", () => {
      if (this.slide) {
        this.onScroll();
      } else {
        this.scrollState = true;
      }
    });
  },
  computed: {
    ...mapState(["path"])
  },
  watch: {},
  created() { },
  methods: {
    onScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 300) {
        this.scrollState = true;
      } else {
        this.scrollState = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../style/mixin";
$headHeight: rem(76);
@media screen and (min-width: 750px) and (max-width: 1320px) {
  #headBox {
    .pageCenter {
      .logo {
        margin-left: 3vw;
        width: 170px !important;
        height: 37px !important;
      }
      ul {
        margin-right: 3vw !important;
        li {
          margin-left: 25px !important;
          font-size: 16px !important;
          height: $headHeight;
          line-height: $headHeight;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) {
  html {
    font-size: 14px;
  }
  #headBox {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 10;
    width: 100%;
    height: $headHeight;
    transition: all 0.6s;
    .suspension {
      display: none;
      cursor: pointer;
      padding: 5px;
      span {
        display: block;
        width: 30px;
        height: 4px;
        border-radius: 6px;
        background: #fff;
        transition: all 0.5s;
        margin: 5px 0;

        &:nth-child(1) {
          transform: rotate(45deg) translateX(6px);
        }
        &:nth-child(2) {
          display: none;
        }
        &:nth-child(3) {
          transform: rotate(-45deg) translateX(6px);
        }
      }
    }
    .pageCenter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: $headHeight;
      .logo {
        width: 170px;
        height: 37px;
        @include bis(
          "http://qn.kemean.cn/upload/202103/22/1616415365768033w93ri.png"
        );
        transition: all 0.6s;
        flex-shrink: 0;
      }
      ul {
        display: flex;
        li {
          margin-left: 40px;
          padding: 0px 5px;
          color: #fff;
          text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 1);
          font-size: 16px;
          height: $headHeight;
          line-height: $headHeight;
          transition: all 0.6s;
          cursor: pointer;
          border-bottom-style: solid;
          border-bottom-width: 2px;
          border-bottom-color: transparent;
          white-space: nowrap;
          &.active {
            border-bottom-color: #fff;
          }
        }
      }
    }
    &.moveDown {
      background-color: #fff;
      border-bottom: 1px solid #eee;
      box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.03);
      .logo {
        background-image: url("http://qn.kemean.cn/upload/202103/22/1616415365768033w93ri.png");
      }
      ul li {
        color: #333;
        text-shadow: none;
        &.active {
          border-bottom-color: $mainColor;
          color: $mainColor;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  #headBox {
    position: fixed;
    top: 2.3vw;
    left: 2.3vw;
    z-index: 10;
    width: 40px;
    transition: all 0.4s;
    height: 40px;
    overflow: hidden;

    &.current {
      top: 0px;
      left: 0px;
      width: 80vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.9);
      .suspension {
        position: absolute;
        right: 5vw;
        top: 5vw;
        background-color: transparent;
        span {
          &:nth-child(1) {
            transform: rotate(45deg) translateX(5px);
          }
          &:nth-child(2) {
            display: none;
          }
          &:nth-child(3) {
            transform: rotate(-45deg) translateX(5px);
          }
        }
      }
      .pageCenter {
        padding: 4vw 0;
        opacity: 1;
        .logo {
          &::before {
            animation: logoAnimation 0.4s linear;
          }
          &::after {
            animation: kemeanAnimation 0.4s linear;
          }
        }
        ul {
          margin-top: 30px;
          li {
            line-height: 50px;
            height: 50px;
            padding-left: 6vw;
            color: #ccc;
            cursor: pointer;
            &.active {
              background-color: rgba(255, 255, 255, 0.2);
            }
          }
        }
      }
    }
    .suspension {
      cursor: pointer;
      padding: 3px 5px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 3px;
      span {
        display: block;
        width: 28px;
        height: 3px;
        border-radius: 6px;
        background: #fff;
        transition: all 0.5s;
        margin: 5px 0;
      }
    }
    // .pageCenter {
    //   opacity: 0;
    //   .logo {
    //     display: flex;
    //     width: 160px;
    //     height: 40px;
    //     flex-shrink: 0;
    //     @include bis("https://qn.kemean.cn/upload/201809/06/logo.png");
    //     margin-left: 23px;
    //   }
    // }
    .pageCenter {
      opacity: 0;
      .logo {
        display: flex;
        width: 170px;
        height: 37px;
        flex-shrink: 0;
        &::before {
          content: "";
          @include bis("../../images/logo.png");
          display: block;
          width: 46px;
          height: 37px;
          background-size: auto 100%;
          background-position: 0 center;
          transform: translateX(6vw) rotate(0deg);
        }
        &::after {
          content: "";
          @include bis("../../images/logo.png");
          display: block;
          width: 128px;
          height: 37px;
          background-size: auto 100%;
          background-position: right center;
          transform: translateX(6vw);
        }
      }
    }
  }
}

@keyframes logoAnimation {
  0% {
    transform: translateX(-100%) rotate(-270deg);
  }
  100% {
    transform: translateX(6vw) rotate(0deg);
  }
}
@keyframes kemeanAnimation {
  0% {
    transform: translateX(6vw) translateY(-4vw) rotate(0deg);
  }
  100% {
    transform: translateX(6vw) translateY(0vw) rotate(0deg);
  }
}
</style>
